import { InvoiceDeliveryMethod } from '@constants'

export const isEmailDeliveryMethod = (method?: string | null): boolean =>
  method === InvoiceDeliveryMethod.EMAIL || method === InvoiceDeliveryMethod.EMAIL_XRECHNUNG

export const isGermanBusinessCountry = (country?: string | null): boolean =>
  (country || '').toLowerCase() === 'de'

const LEITWEG_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9-]{3,44}[A-Za-z0-9]$/
const BUYER_REFERENCE_MIN_LENGTH = 5
const BUYER_REFERENCE_MAX_LENGTH = 45
const SELLER_CONTACT_PHONE_MIN_DIGITS = 3

export const countPhoneDigits = (phone: string): number => (phone.match(/\d/g) || []).length

export const isValidDeSellerContactPhone = (phone?: string | null): boolean => {
  if (!phone?.trim()) {
    return false
  }

  return countPhoneDigits(phone) >= SELLER_CONTACT_PHONE_MIN_DIGITS
}

export const isValidDeBuyerReferenceFormat = (buyerReference: string): boolean => {
  const trimmed = buyerReference.trim()
  if (!trimmed) {
    return true
  }

  if (!/^\d/.test(trimmed)) {
    return true
  }

  const lengthOk =
    trimmed.length >= BUYER_REFERENCE_MIN_LENGTH && trimmed.length <= BUYER_REFERENCE_MAX_LENGTH

  return lengthOk && LEITWEG_ID_PATTERN.test(trimmed)
}
